/* Shazory · Customizer Gate · v1.0
   Blocks /cart/add submissions on Customizer-type product pages when no
   line-item properties are present (i.e. customization was not completed).
   Shows a friendly modal directing the customer back to Teeinblue. */
(function(){
  'use strict';
  if (!window.shazoryRequireCustomization) return;

  function hasCustomizationData(form){
    if (!form) return false;
    // Any line-item property present = customization or Teeinblue interaction happened.
    // Native Shopify add-to-cart without app interaction has no properties.
    var props = form.querySelectorAll('input[name^="properties["]');
    if (props.length === 0) return false;
    // Filter out empty values — Teeinblue and similar apps fill these in.
    for (var i = 0; i < props.length; i++) {
      var v = (props[i].value || '').trim();
      if (v.length > 0) return true;
    }
    return false;
  }

  function showModal(){
    if (document.getElementById('shz-gate-modal')) return;
    var modal = document.createElement('div');
    modal.id = 'shz-gate-modal';
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(15,20,55,0.86);z-index:9999999;display:flex;align-items:center;justify-content:center;padding:20px;font-family:Jost,sans-serif;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)';
    modal.innerHTML =
      '<div role="dialog" aria-modal="true" aria-labelledby="shz-gate-title" style="background:#1A1B2E;border:1px solid #C9A84C;border-radius:8px;max-width:460px;width:100%;padding:40px 28px 32px 28px;position:relative;box-shadow:0 16px 60px rgba(0,0,0,0.55);text-align:center">' +
        '<button id="shz-gate-close" type="button" aria-label="Close" style="position:absolute;top:12px;right:12px;background:transparent;border:1px solid rgba(212,200,224,0.3);color:#F4F0F8;width:30px;height:30px;border-radius:50%;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;padding:0;font-family:Jost,sans-serif">×</button>' +
        '<div style="font-family:Jost,sans-serif;font-size:10px;color:#A88838;letter-spacing:0.16em;text-transform:uppercase;font-weight:500;margin-bottom:12px">One small step</div>' +
        '<div id="shz-gate-title" style="font-family:Cormorant Garamond,Georgia,serif;font-size:30px;color:#E8D89B;font-style:italic;font-weight:300;line-height:1.2;margin-bottom:14px">Add your photo first.</div>' +
        '<p style="font-size:14px;color:#E8E1F0;line-height:1.65;font-weight:300;margin:0 0 28px 0;font-family:Jost,sans-serif">This piece is made to be customized with your own image. Tap the <strong style="color:#E8D89B;font-weight:500">Customize</strong> or <strong style="color:#E8D89B;font-weight:500">Personalize</strong> button on the product page, upload your photo, position it, and save your design — then you can add it to the cart.</p>' +
        '<button id="shz-gate-ok" type="button" style="background:#C9A84C;color:#0F1437;border:none;padding:14px 32px;border-radius:999px;font-family:Jost,sans-serif;font-size:12px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;box-shadow:0 6px 18px rgba(201,168,76,0.3)">Got it</button>' +
      '</div>';
    document.body.appendChild(modal);
    function close(){ if (modal.parentNode) modal.parentNode.removeChild(modal); document.removeEventListener('keydown', onKey); }
    function onKey(e){ if (e.key === 'Escape') close(); }
    document.getElementById('shz-gate-close').addEventListener('click', close);
    document.getElementById('shz-gate-ok').addEventListener('click', close);
    modal.addEventListener('click', function(e){ if (e.target === modal) close(); });
    document.addEventListener('keydown', onKey);
    try { if (typeof gtag === 'function') gtag('event', 'shz_gate_blocked_add_to_cart', { product_url: location.pathname }); } catch(e){}
  }

  // Intercept form submits in CAPTURE phase so we run before Dawn's product-form handler.
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.action || !/\/cart\/add/.test(form.action)) return;
    if (hasCustomizationData(form)) return;

    // Allow bundle-mode add-to-carts to proceed only if Teeinblue properties exist
    // (they will, since Teeinblue is what triggers cart-add in the bundle flow).
    // If somehow user clicked native add-to-cart in bundle mode without customizing,
    // block them too — the gate is consistent.

    e.preventDefault();
    e.stopImmediatePropagation();
    showModal();
    return false;
  }, true);
})();
